module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/myschedule-d7e23186dfbf1aa73d56ba8d02a70b97.svg";